// Mock data for $FOCUS Meme Coin Landing Page

export const heroData = {
  ticker: "$FOCUS",
  tagline: "Lock In. Execute. Win.",
  ctaText: "Buy on Pump.fun",
  ctaLink: "https://pump.fun/profile/work2moon",
  profileUrl: "https://pump.fun/profile/work2moon",
  backgroundImage: "https://images.unsplash.com/photo-1533134486753-c833f0ed4866?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGRhcmt8ZW58MHx8fGJsYWNrfDE3NjkyMDIyMzZ8MA&ixlib=rb-4.1.0&q=85",
  logo: "https://customer-assets.emergentagent.com/job_e2b32889-08a6-4658-90b4-6c79e948e7eb/artifacts/hrm3t61o_ChatGPT%20Image%2023%20Oca%202026%2022_24_00.png"
};

export const aboutData = {
  title: "What is $FOCUS?",
  description: [
    "FOCUS is for builders who ignore noise and execute. No hype. No distractions. Just discipline and results.",
    "In a world of infinite scrolling and dopamine loops, $FOCUS represents the rare breed who lock in and ship.",
    "This isn't just a token. It's a statement. A badge for those who choose execution over excuses."
  ],
  image: "https://images.unsplash.com/photo-1720962158937-7ea890052166?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHw0fHxkYXJrJTIwdGVjaHxlbnwwfHx8YmxhY2t8MTc2OTIwMjIzMHww&ixlib=rb-4.1.0&q=85"
};

export const whyBuyData = {
  title: "Why $FOCUS?",
  points: [
    {
      title: "Lock in while others scroll",
      description: "While they're distracted, you're accumulating."
    },
    {
      title: "Discipline > Dopamine",
      description: "Choose delayed gratification. Choose victory."
    },
    {
      title: "Not for everyone. That's the point.",
      description: "Built for the 1% who actually execute."
    },
    {
      title: "Community of Builders",
      description: "Join the focused few who ship, not talk."
    }
  ]
};

export const socialProofData = {
  title: "The Community Speaks",
  tweets: [
    {
      author: "Sparco DeFi",
      handle: "DefiSparco",
      avatar: "S",
      content: "This is 🔥",
      url: "https://twitter.com/DefiSparco"
    },
    {
      author: "Sparco DeFi",
      handle: "DefiSparco",
      avatar: "S",
      content: "Big potential here",
      url: "https://twitter.com/DefiSparco"
    },
    {
      author: "Solana Gems Finder 💎",
      handle: "9oo8k",
      avatar: "G",
      content: "Let's go big 🚀",
      url: "https://twitter.com/9oo8k"
    },
    {
      author: "Mr.SoL Official 🧑‍🍳",
      handle: "mrsoloffical",
      avatar: "M",
      content: "Amazing project",
      url: "https://twitter.com/mrsoloffical"
    }
  ]
};

export const howToBuyData = {
  title: "How to Buy $FOCUS",
  steps: [
    {
      step: 1,
      title: "Install Phantom Wallet",
      description: "Download Phantom wallet extension for your browser or mobile app.",
      icon: "wallet",
      link: "https://phantom.app/download"
    },
    {
      step: 2,
      title: "Fund with SOL",
      description: "Buy SOL from an exchange and send it to your Phantom wallet.",
      icon: "coins",
      link: null
    },
    {
      step: 3,
      title: "Go to Pump.fun",
      description: "Visit the $FOCUS creator profile on Pump.fun platform.",
      icon: "external-link",
      link: "https://pump.fun/profile/work2moon"
    },
    {
      step: 4,
      title: "Buy $FOCUS",
      description: "Connect wallet, find $FOCUS token, and lock in your bag.",
      icon: "check-circle",
      link: "https://pump.fun/profile/work2moon"
    }
  ]
};

export const memeData = {
  title: "Memes for the Focused",
  subtitle: "Screenshot. Share. Spread the message.",
  memes: [
    {
      image: "https://images.unsplash.com/photo-1570716892027-8347dbdac4aa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxkYXJrJTIwbW90aXZhdGlvbnxlbnwwfHx8YmxhY2t8MTc2OTIwMjIxOXww&ixlib=rb-4.1.0&q=85",
      overlayText: "REFUSE DISTRACTION"
    },
    {
      image: "https://images.unsplash.com/photo-1654198340681-a2e0fc449f1b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMGRhcmt8ZW58MHx8fGJsYWNrfDE3NjkyMDIyMzZ8MA&ixlib=rb-4.1.0&q=85",
      overlayText: "LOCK IN"
    },
    {
      image: "https://images.unsplash.com/photo-1720962158937-7ea890052166?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHw0fHxkYXJrJTIwdGVjaHxlbnwwfHx8YmxhY2t8MTc2OTIwMjIzMHww&ixlib=rb-4.1.0&q=85",
      overlayText: "EXECUTE DAILY"
    }
  ]
};

export const roadmapData = {
  title: "What's Next?",
  teaser: "FOCUS is step 1. Discipline is next.",
  upcomingCoins: [
    { name: "$DISCIPLINE", status: "Coming Soon" },
    { name: "$EXECUTE", status: "Phase 2" },
    { name: "$CONSISTENT", status: "Phase 3" }
  ]
};

export const footerData = {
  brand: "@Work2Moon",
  disclaimer: "This is a meme coin for fun and motivation. Not financial advice. DYOR.",
  socials: [
    { name: "X (Twitter)", url: "https://twitter.com/Work2Moon", icon: "twitter" },
    { name: "Pump.fun Profile", url: "https://pump.fun/profile/work2moon", icon: "rocket" }
  ]
};
